import './CheckoutSteps.css';
import React, { JSX } from 'react';
import { useLocation, useMatch } from 'react-router';
import { Routes } from '../../app/Routes';
import { localized } from '../../config/localization';
import { Step } from './Step';
import { Steps } from './Steps';

export function CheckoutSteps(): JSX.Element | null {
  const location = useLocation();

  const isUploadPage = location.pathname.startsWith(Routes.CHECKOUT);
  const isParametersPage = useMatch(Routes.checkoutParameters(':id')) !== null;
  const isCalculationPage = useMatch(Routes.checkoutCalculation(':id')) !== null;
  const isOrderPage = useMatch(Routes.checkoutOrder(':id')) !== null;
  const isSuccessPage = useMatch(Routes.checkoutSuccess(':id')) !== null;
  const isOrderSuccessPage = isOrderPage || isSuccessPage;

  return (
    <Steps>
      <Step
        number={1}
        name={localized.UPLOAD}
        active={isUploadPage}
        done={isParametersPage || isCalculationPage || isOrderSuccessPage}
      />
      <Step
        number={2}
        name={localized.PARAMETERS}
        active={isParametersPage}
        done={isCalculationPage || isOrderSuccessPage}
      />
      <Step number={3} name={localized.OVERVIEW} active={isCalculationPage} done={isOrderSuccessPage} />
      <Step number={4} name={localized.OFFER} active={isOrderSuccessPage} done={isSuccessPage} />
    </Steps>
  );
}
